import axios from "axios";
import url from "../config/urlServiceConfig";

const sysPerfAPI = {
  getAll: () => axios.get(url.sysPerf),
  update: body => axios.put(url.sysPerf, body)
};

export default sysPerfAPI;
